import React from 'react'

import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

export default function TimesheetTableENG({weekData=[]}) {

  let jobNumToEntries = {};

  weekData.forEach(entry => {
    entry.jobDetails.forEach(detail => {
      if(detail.jobNumber !== 'N/A'){
        let jobNum = detail.jobNumber;

        if(!(jobNum in jobNumToEntries)){
          jobNumToEntries[jobNum] = [];
        }

        let row = {
          FullName: entry.FullName,
          Date: entry.Date,
          'Job Desc': detail.jobDescription,
          'Total Hours': detail.totalHours
        };

        jobNumToEntries[jobNum].push(row);
      }
    });
  });

  // Transform the mapping into the desired format
  let transformedData = Object.entries(jobNumToEntries).map(([jobNum, values]) => {
    let totalHours = values.reduce((total, row) => total + parseFloat(row['Total Hours']), 0);
  
    return {
      Subheading: jobNum,
      TableHeaders: ["Name", "Date", "Job Desc", "Total Hours"],
      Values: values,
      'Total Hours': totalHours.toFixed(2)
    };
  });

  return (
    <>
      <TableContainer component={Paper}>
        <Table aria-label="collapsible table">
          <TableBody>
            <Row data={transformedData} />
          </TableBody>
        </Table>
      </TableContainer>
    </>
  )
}

function Row({data}) {
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell sx={{width: "60px", marginRight: "0px", paddingRight:"0px"}}>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton >
        </TableCell>
        <TableCell sx={{marginLeft: "0px", paddingLeft:"0px"}}>
          <Typography fontWeight="bold">
            Job Breakdown
          </Typography>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              {data.map((entry, index) => (
                <TableContainer key={index}>
                  <Typography variant="h6" gutterBottom component="div" sx={{color: "tomato", fontWeight: "bold" }}>
                    {entry.Subheading}
                  </Typography>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                      <TableCell component="th" scope="row" sx={{fontWeight: 'bold', width: '25%'}}>Date</TableCell>
                        <TableCell sx={{fontWeight: 'bold', width: '25%'}}>Full Name</TableCell>
                        <TableCell align='right' sx={{fontWeight: 'bold', width: '25%'}}>Job Desc</TableCell>
                        <TableCell align='right' sx={{fontWeight: 'bold', width: '25%'}}>Hours</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                    {entry.Values.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell component="th" scope="row">{row.Date}</TableCell>
                        <TableCell>{row.FullName}</TableCell>
                        <TableCell align='right'>{row['Job Desc']}</TableCell>
                        <TableCell align='right'>{row['Total Hours']}</TableCell>
                      </TableRow>
                    ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              ))}
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}